import { styled } from '@mui/material';

export const Highlighted = styled('span')(({ theme, color }) => ({
  display: 'inline-block',
  color: color ? (theme as any)?.palette?.[color]?.main : 'inherit',
}));
